import React, { useState } from "react";
import { Container } from "react-bootstrap";
import img1 from "../../assets/Images/Blogs/bed-arrangements-still-life.jpg";
import img2 from "../../assets/Images/Blogs/pexels-heyho-6492402.jpg";
import { useIsMobile } from "../../utils/responsive";
export default function Section2() {
  const [hoveredImage, setHoveredImage] = useState(null);
  const isMobile = useIsMobile();

  const handleImageHover = (index) => {
    setHoveredImage(index);
  };

  return (
    <Container fluid className="p-0">
      {/* Header Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "60%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              padding: "20px 40px",
            }}
          >
            <h3 className="heading-sm m-0">
              HOW MANY COLORS SHOULD YOU USE IN A ROOM?
            </h3>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "30%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "50%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "100%",
                height: "50%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
          </div>
        )}
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        {/* Text Column */}
        <div
          style={{
            width: isMobile ? "100%" : "60%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          // className="p-5"
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              // borderTop: "1px solid black",
              borderBottom: !isMobile ? "none" : "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                padding: "20px 40px",
              }}
            >
              <p className="body-lg m-0">
                According to the 60-30-10 rule, you should only use three colors
                in any room – although you can successfully incorporate many
                different tones of these three colors. This three-color rule
                will allow you to create a balanced, restful-looking color
                scheme that's difficult to go wrong with.
              </p>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              height: "100%",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "row",
                gap: "0",
                transition: "all 0.5s ease",
              }}
              onMouseEnter={() => handleImageHover(2)}
              onMouseLeave={() => handleImageHover(null)}
            >
              <img
                src={img2}
                alt="Profile 1"
                style={{
                  flex: "1",
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                  transition: "all 0.5s ease",
                  transform: hoveredImage === 2 ? "scale(1.05)" : "scale(1)",
                  filter:
                    hoveredImage === 2 ? "brightness(1.05)" : "brightness(1)",
                }}
              />
            </div>
          </div>
        </div>
        {/* Image Column */}
        <div
          style={{
            width: isMobile ? "100%" : "30%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "row",
              gap: "0",
              transition: "all 0.5s ease",
            }}
            onMouseEnter={() => handleImageHover(1)}
            onMouseLeave={() => handleImageHover(null)}
          >
            <img
              src={img1}
              alt="Profile 1"
              style={{
                flex: "1",
                objectFit: "cover",
                width: "100%",
                height: "100%",
                transition: "all 0.5s ease",
                transform: hoveredImage === 1 ? "scale(1.05)" : "scale(1)",
                filter:
                  hoveredImage === 1 ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
